import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { App } from '@store/actions/app.actions';
import { CompanyActions } from '@store/actions/company.actions';
import { CompanyService } from '@modules/shared/services/company.service';

@Injectable()
export class CompanyEffects {
  actions$ = inject(Actions);
  private companyService = inject(CompanyService);

  getCompanies$ = createEffect(() => this.actions$.pipe(
    ofType(CompanyActions.GET_COMPANIES, App.INITIALIZE),
      exhaustMap(() => this.companyService.getAll()
        .pipe(
          map(payload => ({type: CompanyActions.GET_COMPANIES_SUCCESS, payload})),
          catchError(error => of(({type: CompanyActions.GET_COMPANIES_FAILED, error}))),
        )),
    ),
  );

  updateCompany$ = createEffect(() => this.actions$.pipe(
      ofType(CompanyActions.UPDATE_COMPANY),
    exhaustMap((payload: any) => {
      return this.companyService.update(payload)
        .pipe(
          map(payload => ({type: CompanyActions.UPDATE_COMPANY_SUCCESS, payload})),
          catchError(error => of(({type: CompanyActions.UPDATE_COMPANY_FAILED, error}))),
        );
    }),
    ),
  );

  createCompany$ = createEffect(() => this.actions$.pipe(
      ofType(CompanyActions.CREATE_COMPANY),
      exhaustMap((payload) => this.companyService.create(payload as any)
        .pipe(
          map(payload => ({type: CompanyActions.CREATE_COMPANY_SUCCESS, payload})),
          catchError(error => of(({type: CompanyActions.CREATE_COMPANY_FAILED, error}))),
        )),
    ),
  );

  deleteCompany$ = createEffect(() => this.actions$.pipe(
      ofType(CompanyActions.DELETE_COMPANY),
      exhaustMap(({payload}: any) => this.companyService.delete(payload)
        .pipe(
          map(payload => ({type: CompanyActions.DELETE_COMPANY_SUCCESS, payload})),
          catchError(error => of(({type: CompanyActions.DELETE_COMPANY_FAILED, error}))),
        )),
    ),
  );
}
